import i18next from 'i18next';

export const getOrderLabel = (ordersAmount: number) => {
   const pluralRules = new Intl.PluralRules('pl-PL');
   const grammaticalNumber = pluralRules.select(ordersAmount);
   return grammaticalNumber === 'one'
      ? i18next.t('labels.order_one')
      : i18next.t('labels.address_many');
};
